import React from 'react';

import { Card, CardText, CardMedia, CardTitle, CardActions } from 'material-ui/Card';

import FlatButton from 'material-ui/FlatButton';

import {indigo400,redA400,lightBlueA400,amberA400} from 'material-ui/styles/colors';

import FadeAndScale from '../animations/FadeAndScale';


export default class PlaceCard extends React.Component{
  constructor(props){
      super(props);
      this.state = {
        show: true
      }
  }

  render(){
    return(
      <FadeAndScale className="col-xs-12 col-sm-4"  in={this.props.in}>
        <div>
          <Card style={{ 'background': '#111' }}>
            <CardMedia>
              <img src={ process.env.PUBLIC_URL + this.props.place.imageUrl }/>
            </CardMedia>
            <CardTitle style={{ 'color':'#ffea00' }}>{ this.props.place.title }</CardTitle>
            <CardText style={{ 'color':'#FFFFFF' }}>{this.props.place.description}</CardText>
            <CardActions>
              <FlatButton secondary={true} label="More"/>
              <FlatButton primary={true} onClick={()=> this.props.onRemove(this.props.place)} label="Next" />
            </CardActions>
          </Card>
        </div>
      </FadeAndScale>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/places/PlaceCard.js